import HasID from "./HasID";
import {create, Delta} from "jsondiffpatch";

export interface History extends HasID {
    oldValue: string;
    newValue: string;
    updated: Date;
    updatedBy: string;
    noMeaningfulChanges?: boolean;
}

export function historyDiff(history: History): Delta | undefined {
    const jsondiffpatch = create({
        propertyFilter: function(name: string) {
            if (name == "Updated") return false;
            if (name == "UpdatedBy") return false;
            return true;
        }
    });

    let oldValue: any;
    if (history.oldValue) oldValue = JSON.parse(history.oldValue)[0];
    const newValue = JSON.parse(history.newValue)[0];

    Object.keys(newValue).forEach((h : any) => {
        if (Array.isArray(newValue[h]) && oldValue && !oldValue[h])
            oldValue[h] = [];
    })

    Object.keys(oldValue ?? {}).forEach((h : any) => {
        if (Array.isArray(oldValue[h]) && !newValue[h])
            newValue[h] = [];
    })

    return jsondiffpatch.diff(oldValue, newValue);
}
